export default class BlockchainSettings {
  constructor(data) {
    this.basicCurrency = data?.basicCurrency;
    this.blockchainNetwork = data?.blockchainNetwork ?? '';
    this.typeCryptoCurrency = data?.typeCryptoCurrency ?? 'CURRENCY';
    this.unit = data?.unit ?? 1000000;
  }
}
